<template>
  <el-dialog
    title="上会设置"
    :visible="visible"
    class="approveDialogWrap"
    width="500px"
    :before-close="handleClose"
  >
    <div class="backWrap">
      <el-form
      :model="dataForm"
      :rules="rules"
      ref="dataForm"
      label-width="100px"
      class="dataForm"
    >
        <el-row>
          <el-col :span="24">
            <el-form-item label="是否上会" prop="submitStatus" label-width="100px">
              <el-select
                v-model="dataForm.submitStatus"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in options"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上会说明" label-width="100px" prop="submitDesc">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="dataForm.submitDesc"
                maxlength="200"
                size="medium"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
    </el-form>
    <div class="bottomBtn">
      <el-button type="info" @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 认</el-button
      >
      
    </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  updateUpMeetingStatus,
  updateMulUpMeetingStatus,  //批量修改上会状态
} from "@/services/declarationServices";
import Consts from "@/utils/consts";
export default {
  name: "dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      dataForm:{
        idSet:[],
        submitStatus:'', //上会状态
        submitDesc:'', //上会说明
      },
      options: [
        {
          label: "未上会",
          value: 0,
        },
        {
          label: "已上会",
          value: 1,
        },
        {
          label: "无需上会",
          value: 2,
        },
        {
          label: "驳回",
          value: 3,
        },
      ],
      rules: {
        submitStatus: [
          { required: true, message: "请选择上会状态", trigger: "change" },
        ],
        submitDesc: [
          { required: true, message: "请输入上会说明", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // handleConfirm(submitStatus) {
    //   if (!this.dataForm.submitDesc) {
    //     this.$message.warning("请输入上会说明");
    //     return;
    //   }
    //   this.$emit("handleChange", true, { submitDesc: this.dataForm, submitStatus });
    //   this.submitDesc = "";
    // },
    handleClose() {
      this.$emit("handleChange", false, {});
      this.dataForm.submitDesc = "";
    },
    // 修改上会状态
    handleConfirm() {
       this.$refs.dataForm.validate((valid) => {
        if (valid) {
      this.$confirm("确认修改吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.dataForm.idSet=this.id.map(e=>{return e.id})
          return updateMulUpMeetingStatus(this.dataForm);
        })
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            this.$alert(Consts.Ok_Msg, "提示");
            // 撤回成功后，刷新一下当前页码的数据。
            // 省点的就是修改单条提报单的数据，重新获取的好处就是能获取全部的最新数据。
            this.$emit("handleChange", true);
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          console.log(error);
        });
        }
       })
    },

  },
};
</script>

<style scoped lang="scss">
.bottomBtn{
  width: 100%;
  text-align: center;
}
</style>
